(function(){
	'use_strict';

	var injectParams = ['Shoveler'];
	
	var filterController = function( Shoveler ){

		var self = this;
		
		self.shovelers = [];
		self.filteredShovelers = [];
		self.memberOnly = false;
		self.states = [];
		self.filterState = 'all';
		self.activeStates = [];
		self.hasNoResult = false;

		if( gfShovelers.length > 0 ){

			var _shovelers = [];
			angular.forEach(gfShovelers, function( value, key ){
				var shoveler = new Shoveler( value );
				
				_shovelers.push( shoveler );
				if( self.states.indexOf( shoveler.state ) === -1 ){
					if (shoveler.state !== '') {
						self.states.push( shoveler.state );	
					}	
				}
			});

			self.shovelers  = _shovelers;
			self.filteredShovelers = self.shovelers;
		}

		
		self.stateActive = function( state ){
			var shovlerExists = false;
			
			angular.forEach( self.filteredShovelers, function( shoveler, key ){
				if (shoveler.state == state) {
					shovlerExists = true;
					return;
				}
			});

			if( ( self.filterState == 'all' || state === self.filterState ) && shovlerExists){
				return true;
			}
			return false;
		};    


	    self.memberFilter = function(){
	    	self.filteredShovelers = self.shovelers;
	        

	        if( self.memberOnly ){

	        	var filtered = [];
	        	angular.forEach( self.shovelers, function( shoveler, key){
	        		if (shoveler.member) {
	        			filtered.push( shoveler );
	        		}
	        	});

	        	self.filteredShovelers = filtered;
	        }

	        
	        if( self.filterState != 'all' ){
	        	var available = [];
	        	
	        	angular.forEach( self.filteredShovelers, function( shoveler, key ){
	        		if (shoveler.state == self.filterState) {
	        			available.push( shoveler );
	        		}
	        	} );

	        	self.filteredShovelers = available;	
	        }


	        // self.hasNoResult = false;
	        // if (self.filteredShovelers.length === 0) {
	        // 	self.hasNoResult = true;
	        // } 

	    };

		return self;
	};


	filterController.$inject = injectParams;
	angular.module('shoveler-filter').controller( 'filterController', filterController );
})();